import { FlagIcon } from "react-flag-kit";
const occtooLanguages = JSON.parse(process.env.REACT_APP_OCCTOO_LANGUAGES);

// Define the global languages
//export const languages = ["en", "sv-SE", "no", "fi-FI"];
/*export const languageIcons = {
  en: <FlagIcon code="GB" size={16} />,
  "sv-SE": <FlagIcon code="SE" size={16} />,
  no: <FlagIcon code="NO" size={16} />,
  "fi-FI": <FlagIcon code="FI" size={16} />,
};*/

// `source` is optional; fall back to `code` so envs without it still work.
export const languageMapping = occtooLanguages.map((l) => ({
  ...l,
  source: l.source ?? l.code,
}));
export const languages = languageMapping.map((l) => l.source);
export const languageIcons = Object.fromEntries(
  occtooLanguages.map(({ code, flag }) => [
    code,
    <FlagIcon key={code} code={flag} size={16} />,
  ]),
);

// Create an object with empty strings for each language
export const emptyLocalizedFields = languages.reduce((acc, lang) => {
  acc[lang] = "";
  return acc;
}, {});

export const localizeField = (data, field) => {
  //  const allowed = new Set(languages);
  const languageCodes = languageMapping.map((item) => item.code);
  const allowed = new Set(languageCodes);
  return data.reduce((acc, item) => {
    const lang = item._language;

    if (!allowed.has(lang)) return acc;
    const source = languageMapping.find((f) => f.code === lang)?.source;
    acc[source] = item[field] ?? "";
    return acc;
  }, {});
};

export const defaultLanguage = languages[0];
